/* Dialog Text */
import { Component, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import {
  InteractSubContents,
  InteractSubTypeLicenses,
  Interacts,
  Interact,
} from "../../../api/models";
import { AdminInteractiveSubService } from "../../../api/services";
import {
  TextEditDialogData,
  TextEditDialogComponent,
} from "../../text-edit-dialog/text-edit-dialog.component";

export interface EditInteractiveSubscriptionsDialogData {
  dialogTitle: string;
  isNew: boolean;
  interactSubTypeId: number;
  interactives: Interacts[];
  interactSubTypeName: string;
  description: string;
  marketingUrl: string;
  adminInteractiveSubService: AdminInteractiveSubService;
  appliedInteractives: Interacts[];
  appliedLicenses: InteractSubTypeLicenses[];
  restrictPurchaseEmails: string[];
  licenseText: string;
}

@Component({
  selector: "edit-interactive-subscription-dialog",
  styleUrls: ["edit-interactive-subscription-dialog.component.css"],
  templateUrl: "./edit-interactive-subscription-dialog.component.html",
})
export class EditInteractiveSubscriptionsDialogComponent {
  public Result: DialogResult;
  public selectedInteractive: Interacts = null;
  public isLoading: boolean = true;
  public ToAddEmail: string = "";

  constructor(
    public dialogRef: MatDialogRef<EditInteractiveSubscriptionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: EditInteractiveSubscriptionsDialogData,
    private dialog: MatDialog
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;

    if (this.data.isNew) {
      this.isLoading = false;
    } else {
      this.data.adminInteractiveSubService
        .adminInteractiveSubGetInteractSubTypeInteractives(
          this.data.interactSubTypeId
        )
        .subscribe((result1) => {
          this.data.adminInteractiveSubService
            .adminInteractiveSubGetInteractSubLevels2(
              this.data.interactSubTypeId
            )
            .subscribe((result2) => {
              this.data.adminInteractiveSubService
                .adminInteractiveSubGetInteractSubTypeLicenses(
                  this.data.interactSubTypeId
                )
                .subscribe((result3) => {
                  this.data.adminInteractiveSubService
                    .adminInteractiveSubGetInteractSubTypesRestrictedUsers(
                      this.data.interactSubTypeId
                    )
                    .subscribe((result4) => {
                      this.data.appliedInteractives = result1;
                      this.data.appliedLicenses = result3;

                      for (var i = 0; i < result4.length; i++) {
                        this.data.restrictPurchaseEmails.push(
                          result4[i].emailAddress
                        );
                      }

                      this.isLoading = false;
                    });
                });
            });
        });
    }
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }

  onAddInteractive() {
    let wasFound = false;
    for (var i = 0; i < this.data.appliedInteractives.length; i++) {
      if (
        this.data.appliedInteractives[i].interactId ==
        this.selectedInteractive.interactId
      ) {
        wasFound = true;
      }
    }

    if (!wasFound) {
      this.data.appliedInteractives.push(this.selectedInteractive);
    }
  }

  onRemoveInteractive(isb: InteractSubContents) {
    var selectedIndex = -1;
    for (var i = 0; i < this.data.appliedInteractives.length; i++) {
      if (this.data.appliedInteractives[i].interactId == isb.interactId) {
        selectedIndex = i;
        break;
      }
    }

    if (selectedIndex != -1) {
      this.data.appliedInteractives.splice(selectedIndex, 1);
    }
  }

  editLicense() {
    var params: TextEditDialogData = {
      title: "Add / Edit License",
      prompt: "Enter license HTML below",
      data: this.data.licenseText,
    };

    var dialogRef = this.dialog.open(TextEditDialogComponent, {
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        this.data.licenseText = result.ResultData;
      }
    });
  }

  addRestrictedEmail() {}

  onRemoveEmail(toRemoveEmail: string) {}
}

/* Calling Methods */
/*
  callEditInteractiveSubscriptions(params: EditInteractiveSubscriptionsDialogData) {
    var dialogRef = this.dialog.open(EditInteractiveSubscriptionsDialogComponent, {
      width: '500px',
      data: params
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
        //Do something here!
      }
    });
  }
*/
